import * as React from 'react';
import { Button, makeStyles, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    backgroundColor: props.disabled ? '#adb5bd' : theme.palette.primary.main,
    color: '#fff !important',
    '&:hover.Mui-disabled': {
      backgroundColor: props.disabled ? '#adb5bd' : theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: props.hoverBackgroundColor
        ? props.hoverBackgroundColor
        : 'default',
    },
  }),
  loadingStyle: {
    width: '.5rem',
    height: '.5rem',
  },
  noTranslate: {
    '&:hover': {
      transform: 'none !important',
    },
  },
}));
const AgapeButton = ({
  children,
  loading = false,
  loadingSize = 30,
  customClassName,
  backgroundColor,
  hoverBackgroundColor,
  noTranslate,
  ...props
}) => {
  const classes = useStyles({ hoverBackgroundColor, noTranslate, props });

  return (
    <Button
      className={clsx(
        classes.root,
        noTranslate && classes.noTranslate,
        customClassName && customClassName
      )}
      color={backgroundColor}
      {...props}
    >
      {loading ? (
        <CircularProgress size={loadingSize} color="white" />
      ) : (
        children
      )}
    </Button>
  );
};

export default AgapeButton;
